import React from 'react';

import useAudienceChartData from './useAudienceChartData';
import VerticalBars from '../../../../../../components/charts/chartjs/vertical-bars/VerticalBars';
import VerticalBarTooltipLabels from '../../../../../../components/charts/chartjs/vertical-bars/vertical-bar-tooltip-labels/VerticalBarTooltipLabels';

import scss from './CompareChart.module.scss';

function CompareChart({ selectedAudienceFilter, isFiltersApplied }) {
  const { chartLabels, datasets, chartsConfig } = useAudienceChartData(selectedAudienceFilter, isFiltersApplied);

  return (
    <div className={scss.chartWrapper}>
      <VerticalBars
        height={'300px'}
        data={{
          labels: chartLabels,
          datasets: datasets,
        }}
        config={chartsConfig}
      />
      <VerticalBarTooltipLabels labels={chartLabels} />
    </div>
  );
}

export default CompareChart;
